/* Naiak - Card de produto: seletor de quantidade (- / +) ao lado do botão de compra.
   O <product-form> do Dawn envia o campo name="quantity" junto com o id da variante. */
(() => {
  if (window.tpNkCardQuantity) return;
  window.tpNkCardQuantity = true;

  const setQuantity = (input, value) => {
    const min = Number(input.min) || 1;
    const max = Number(input.max) || 99;
    const quantity = Number.isFinite(value) ? Math.round(value) : min;
    input.value = Math.min(max, Math.max(min, quantity));
  };

  document.addEventListener('click', (event) => {
    const step = event.target.closest('[data-nk-card-step]');
    if (!step) return;

    const input = step.closest('.tp-nk-card__quantity')?.querySelector('.tp-nk-card__quantity-input');
    if (input) setQuantity(input, Number(input.value) + Number(step.dataset.nkCardStep));
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches('.tp-nk-card__quantity-input')) setQuantity(event.target, Number(event.target.value));
  });
})();
